import { BaseApiRequest } from "../baseApiRequest";
import { XcoreCore } from "XcoreCore";
import { parseQueryParamsObject } from "@robe/core-utils";
import { baseWebFetchOptions } from "./options";
import { resolveWebLostPasswordErrorParams, WebLostPasswordError } from "../errors";

export interface LostPasswordParams {
  email: string;
  /** Url that is being send to user in email */
  newPassPageUrl: string;
  locale: string;
}

/**
 * @throws {WebLostPasswordError}
 */
export const lostPassword = (core: XcoreCore, { locale, newPassPageUrl, ...params }: LostPasswordParams): BaseApiRequest<Response> =>
  core
    .fetch(`/api/web/lost-password${parseQueryParamsObject({ locale })}`, {
      ...baseWebFetchOptions,
      method: "POST",
      body: JSON.stringify({
        ...params,
        url: newPassPageUrl,
      }),
    })
    .catch((err) => {
      const lostPasswordError = resolveWebLostPasswordErrorParams(err);
      if (lostPasswordError) {
        throw new WebLostPasswordError(lostPasswordError);
      }

      throw err;
    });
